// ets_tracing: off
import { mapWithIndex } from "@effect-ts/core/Collections/Immutable/Dictionary";
export const Ctors = tag => keys => {
  const ctors = mapWithIndex((key, _) => props => ({ ...props,
    [tag]: key
  }))(keys);
  return {
    of: ctors,
    as: ctors,
    make: a => a,
    tag
  };
};
//# sourceMappingURL=index.mjs.map